import React, { useEffect } from 'react'
import { toast } from 'react-toastify'
import { useSelector, useDispatch } from 'react-redux'
import { logout } from 'redux/auth/actions'

import useRouter from 'utils/useRouter'
import { getUserTokenState, AuthStates, Scopes } from "../utils/authUtils"
import { ROUTE_CONSTANTS } from "../utils/constants/routeConstants"

const SecuredRoute = ({ parent: Parent, child, requiredScopes, ...rest }) => {
  const dispatch = useDispatch()
  const router = useRouter()

  const token = useSelector((state) => state.auth.access_token)
  let tokenState = AuthStates.FORBIDDEN
  
  if (token) {
    tokenState = getUserTokenState(
      token,
      requiredScopes || [Scopes.ACCESS],
    )
  }

  useEffect(() => {
    if (tokenState === AuthStates.AUTHORIZED) {
      return
    }

    if (tokenState === AuthStates.EXPIRED) {
      toast.warn('Seu acesso expirou, faça login novamente.')
    }
        
    dispatch(logout())
    router.history.push({
      pathname: ROUTE_CONSTANTS.LOGIN,
      state: { from: router.location.pathname },
    })
  }, [token])
  
  if (tokenState === AuthStates.AUTHORIZED) {
    return <Parent component={child} {...rest} />
  }
  
  return null
}

export default SecuredRoute
